export default {
  quick_links: {
    title: 'Быстрые ссылки',
    developers: 'Застройщики',
    agencies: 'Агентства',
    properties: 'Объекты',
  },
  company: {
    title: 'О компании',
    about_services: 'О сервисе',
    news: 'Новости',
    statistic: 'Статистика',

  },
  support: {
    title: 'Поддержка',
  },
  get_in_touch: 'Связаться с нами',
  email: 'info(at)estimator24.com',
  phone: '+41762378017',
  copyright: 'Estimator24.com'
}
